__webpack_require__.p = "https://certificate.quantstamp.com/full/stake-stone-stone-btc-and-vault/5fbbae75-0726-40d4-ad39-15491f27b400/";